import { Banner, Text } from '@cloudflare/kumo'
import {
  formulaVersionDiffLines,
  type FormulaVersionDiffLabels,
  type QuoteFormulaBasis,
} from '@repo/shared'
import { fmtMoney } from '../lib/format'

/** 차이 줄 낱말 (앱 버전 기록 화면의 한국어와 같은 뜻) */
const DIFF_LABELS: FormulaVersionDiffLabels = {
  change: { added: '추가', removed: '빠짐', changed: '바뀜' },
  costPerUnit: '개당 원가',
  suggestedRetail: '판매가',
  marginPct: '마진',
  batchUnits: '배치 수량',
  stepsChanged: '공정이 바뀌었어요.',
  otherChanged: '그 밖의 내용도 바뀌었어요.',
}

/**
 * 견적 기준 배합 (C43). 견적은 접수 순간의 배합 버전으로 고정된다. 스펙시트(요청서)가 그 버전 기준이고, 연결 제품을
 * 열면 지금 배합이 보이므로, 그 뒤 고친 것이 있으면 무엇이 다른지 알린다. 고정이 없는 견적(버전 기록 꺼짐)은 그리지 않는다
 */
export function QuoteFormulaBasisBanner({
  basis,
  currency,
}: {
  basis: QuoteFormulaBasis | null | undefined
  currency: string
}) {
  if (!basis) return null
  if (basis.current)
    return (
      <Text variant="secondary" size="sm">
        견적 기준 배합 v{basis.number} · 지금 배합과 같아요
      </Text>
    )
  const lines = basis.diff
    ? formulaVersionDiffLines(basis.diff, DIFF_LABELS, (n) => fmtMoney(n, currency))
    : []
  return (
    <Banner
      variant="alert"
      title={`이 견적은 이전 기준(v${basis.number})이에요`}
      description={
        <div className="flex flex-col gap-1">
          <span>
            접수 뒤 사용자가 배합을 고쳤어요. 스펙시트는 접수 때 배합이에요. 지금 배합과 다른 점:
          </span>
          <ul className="list-disc pl-5">
            {(lines.length > 0 ? lines : ['재료·원가·공정은 같고 그 밖의 내용만 바뀌었어요.']).map(
              (line, i) => (
                <li key={i}>{line}</li>
              ),
            )}
          </ul>
        </div>
      }
    />
  )
}
